import { useFeatureGate } from '@statsig/expo-bindings';
import { Redirect, router } from 'expo-router';
import { ScreenContainer, useToastController, YStack } from 'smoothie';

import PaymentMethodForm from '../../../../billing/components/PaymentMethodForm';
import { FeatureFlags } from '../../../../feature-flags/FeatureFlags';
import {
    SUCCESS_TOAST_DURATION,
    SuccessToastIcon,
} from '../../../../member-profile/components/SuccessToast';

export default function PaymentMethodAddPage() {
    const toast = useToastController();
    const { value: isBillingSettingsEnabled } = useFeatureGate(
        FeatureFlags.ENABLE_BILLING_SETTINGS,
    );

    if (!isBillingSettingsEnabled) {
        return <Redirect href="/settings/membership" />;
    }

    return (
        <ScreenContainer
            title="Add payment method"
            hasBackButton
            onFallbackRoute="/settings/membership"
        >
            <YStack gap={16} width="100%">
                <PaymentMethodForm
                    submitLabel="Add"
                    onSuccess={() => {
                        toast.show('Payment method added', {
                            duration: SUCCESS_TOAST_DURATION,
                            icon: SuccessToastIcon,
                        });
                        router.replace('/settings/membership');
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
}
